import React, { Component, Fragment } from 'react';
// Data
import storeConnect from 'data/store-connect';
import authStore, {
  signInWithFacebook,
  signInWithGoogle,
  signInEmail,
  signUpEmail
} from 'data/auth';
// Components
import styles from './login.scss';
import Card from 'ui/card';
import Form, { TextField } from 'ui/form';
import Button from 'ui/button';
import { ICON_GOOGLE, ICON_FACEBOOK, ICON_EMAIL } from 'icons';
import { LoaderOverlay } from 'ui/loader';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Fade } from 'ui/transition';
interface SignInProps extends RouteComponentProps {
  isAuth: boolean;
}

@storeConnect({ isAuth: () => authStore.isAuthenticated() }, [authStore])
class SignIn extends Component<SignInProps> {
  state = { loading: false, showEmail: false };
  get redirect() {
    let m = (location.search || '').match(/(\?|&)r=(.+?)(?=($|&))/);
    if (m) return decodeURIComponent(m[2].replace('login', ''));
    return '/';
  }

  handleBack = () => this.setState({ showEmail: false, register: false });

  handleEmail = () => this.setState({ showEmail: true });

  handleRegisterShow = () => this.setState({ register: true });
  handleRegister = async(form = {}) => {
    const { email, password, rePassword } = form;

    if (!email) return this.setState({ error: 'Missing email' });
    if (!password || password.length < 5) {
      return this.setState({ error: 'Password bust be at least 5 characters' });
    }

    if (password !== rePassword) return this.setState({ error: 'Passwords don\'t match' });
    this.setState({ loading: true });
    try {
      await signUpEmail(email, password);
    } catch (e) {
      this.setState({ loading: false, error: e.message });
    }
  };

  handleLogin = async(form = {}) => {
    const { email, password } = form;

    if (!email) return this.setState({ error: 'Missing email' });
    if (!password || password.length < 5) {
      return this.setState({ error: 'Password bust be at least 5 characters' });
    }
    this.setState({ loading: true });
    try {
      await signInEmail(email, password);
    } catch (e) {
      this.setState({ loading: false, error: e.message });
    }
  };

  handleGoogle = async() => {
    this.setState({ loading: true });
    try {
      await signInWithGoogle();
    } catch (e) {
      this.setState({ loading: false, error: e.message });
    }
  };
  // handleFacebook = async() => {
  //   this.setState({ loading: true });
  //   try {
  //     await signInWithFacebook();
  //   } catch (error) {
  //     this.setState({ loading: false, error });
  //   }
  // };

  render() {
    const { loading, showEmail, register, formData, error } = this.state;
    return (
      <div className={styles.root}>
        {this.props.isAuth && <Redirect to={this.redirect} />}
        <LoaderOverlay show={loading} />

        <Card className={styles.holder}>
          <div className={styles.logo} />
          <h3 className="text-center text-fade">Sign in</h3>
          <div className="tiny-margin">
            <Button
              className="tiny-margin"
              primary={showEmail}
              big
              icon={ICON_EMAIL}
              onClick={this.handleEmail}
            />
            {/* <Button
                className="tiny-margin"
                big
                icon={ICON_FACEBOOK}
                onClick={this.handleFacebook}
              /> */}
            <Button className="tiny-margin" big icon={ICON_GOOGLE} onClick={this.handleGoogle} />
          </div>
          <Fade in={!!error} className="text-error text-center tiny-padding">
            {error}
          </Fade>
          <Fade in={showEmail}>
            <Form
              formData={formData}
              onSubmit={register ? this.handleRegister : this.handleLogin}
              noButtons
            >
              <TextField label="Email" name="email" type="email" autoFocus />
              <TextField label="Password" type="password" name="password" />
              <Fade in={register}>
                <TextField label="Repeat password" type="password" name="rePassword" autoFocus />
              </Fade>
              <div className="text-center">
                {!register && (
                  <Fragment>
                    <Button type="submit" flat="Login" className="tiny-margin" />
                    <Button
                      flat="Register"
                      onClick={this.handleRegisterShow}
                      className="tiny-margin"
                    />
                  </Fragment>
                )}
                {register && (
                  <Fragment>
                    <Button flat="Back" className="tiny-margin" onClick={this.handleBack} />
                    <Button type="submit" flat="Register" className="tiny-margin" />
                  </Fragment>
                )}
              </div>
            </Form>
          </Fade>
        </Card>
      </div>
    );
  }
}
export default SignIn;
